/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useMemo } from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import PostInspectionDiyQuestions from "../post-inspection-diy-accept-price/questions";
import { QUESTION_KEYS } from "../post-inspection-diy-accept-price/constant";
import { NUMBER } from "../../../constants/app-constants";
import { getQuestionList } from "../post-inspection-diy-accept-price/selector";
import { diyLoanCreditMobileErrorSubmitted, diyLoanCreditReportSubmitted } from "./tracking";
import { sendCustomGaEvents } from "../../../tracking";

const PostInspectionCibilContainer = ({
    inspectionResponse,
    submitCibilConsentConnect,
    submitCibilNumberConnect,
    loanDetails,
    setShowCibilQuestions = () => {}
}) => {

    const {
        token,
        appointmentId
    } = inspectionResponse || {};
    const {
        consent = true,
        creditReportPhoneError = false,
        creditReportMaskedPhone: encryptedMobileNumber = ""
    } = loanDetails;

    const [isLoading, setIsLoading] = useState(false);
    const questionList = useMemo(() => getQuestionList({consent, creditReportPhoneError}), []) || [];

    const callGaHandler = (details) => {
        sendCustomGaEvents({
            eventLabel: appointmentId,
            ...details}
        );
    };

    const cibilConfirmationHandler = (question = {}, mobile = "") => {
        if (question.key === QUESTION_KEYS.CONSENT) {
            callGaHandler(diyLoanCreditReportSubmitted);
            return submitCibilConsentConnect(token, {
                "consent": true,
                "source": "MWEB"
            });
        } else if (question.key === QUESTION_KEYS.CIBIL) {
            callGaHandler(diyLoanCreditMobileErrorSubmitted);
            return submitCibilNumberConnect(token, {
                "phone": mobile,
                "source": "MWEB"
            });
        }
        return null;
    };

    const onConfirmation = (question = {}, mobile = "") => {
        setIsLoading(true);
        const cibilHandler = cibilConfirmationHandler(question, mobile);
        cibilHandler.then(() => {
            setIsLoading(false);
            setShowCibilQuestions(false);
        }).catch(() => {
            setIsLoading(false);
        });
    };

    return (
        <>
            {questionList.length > NUMBER.ZERO &&
                <PostInspectionDiyQuestions
                    isLoading={isLoading}
                    questionList={questionList}
                    onConfirmation={onConfirmation}
                    encryptedMobileNumber={encryptedMobileNumber}
                    showCibilQuestions={true}
                    allowClosePopup={false}
                    appointmentId={appointmentId}
                />}
        </>
    );
};

PostInspectionCibilContainer.propTypes = {
    inspectionResponse: PropTypes.object,
    submitCibilNumberConnect: PropTypes.func,
    submitCibilConsentConnect: PropTypes.func,
    loanDetails: PropTypes.object,
    setShowCibilQuestions: PropTypes.func
};

export default PostInspectionCibilContainer;
